import { t } from "@lingui/macro";
import { get } from 'bukku/shared/ApiService';
import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import { errorSagaFn, requestSagaPullingFn, successSagaFn } from "../helper";
import actions from './actions';

// const apiUrl = process.env.REACT_APP_API_URL;

const successKeys = [
    actions.AI_SEARCH_CLASSIFICATION_CODE_SUCCESS,
    actions.AI_SEARCH_MSIC_CODE_SUCCESS,
];

const errorKeys = [
    actions.AI_SEARCH_CLASSIFICATION_CODE_ERROR,
    actions.AI_SEARCH_MSIC_CODE_ERROR,
];

const getSuccessMsg = action => {
    const { type } = action; // { data, type }
    switch (type) {
        case actions.AI_SEARCH_CLASSIFICATION_CODE_SUCCESS:
            return t`Classification code found.`;
        case actions.AI_SEARCH_MSIC_CODE_SUCCESS:
            // if (errorMsg)
            //     return null; // reducer will show the error message
            return t`MSIC code found.`;
        default:
            return null;
    }
};

export function* searchMsicCode() {
    yield takeEvery(actions.AI_SEARCH_MSIC_CODE_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(
            action,
            function* ({description}) {
                const request = {description};

                // if (true) {
                const response = yield call(get, '/ai/search/msic_code', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.AI_SEARCH_MSIC_CODE_SUCCESS,
                    msicCode: data.msic_code,
                    // errorMsg: data.message,
                });
                // }
                // else {
                // yield delay(1000);
                // yield put({
                //     type: actions.AI_SEARCH_MSIC_CODE_SUCCESS,
                //     // msicCode: "62010",
                //     errorMsg: "test error msg",
                // });
                // }
            },
            false, // don't triggerAppPulling
        );
    });
}

export function* searchClassificationCode() {
    yield takeEvery(actions.AI_SEARCH_CLASSIFICATION_CODE_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(
            action,
            function* ({name}) {
                const request = {name};
                const response = yield call(get, '/ai/search/classification_code', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.AI_SEARCH_CLASSIFICATION_CODE_SUCCESS,
                    classificationCode: data.classification_code,
                });
            },
            false, // don't triggerAppPulling
        );
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),

        fork(searchMsicCode),
        fork(searchClassificationCode),
    ]);
}
